function SorterDoubleArrow({ size = '22', style = {}, color = '#3A416F' }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="6 0 11 22"
      fill="none"
    >
      <g opacity="0.5">
        <path
          d="M9.46857 12.9382H1.53149C1.29343 12.9382 1.1605 13.1896 1.30793 13.3612L5.27647 17.963C5.39006 18.0947 5.60879 18.0947 5.72359 17.963L9.69213 13.3612C9.83956 13.1896 9.70663 12.9382 9.46857 12.9382Z"
          fill="url(#paint0_linear_278:11220)"
        />
        <path
          d="M9.69213 9.63879L5.72359 5.03702C5.61 4.9053 5.39127 4.9053 5.27647 5.03702L1.30793 9.63879C1.1605 9.81039 1.29343 10.0617 1.53149 10.0617H9.46857C9.70663 10.0617 9.83956 9.81039 9.69213 9.63879Z"
          fill="url(#paint1_linear_278:11220)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_278:11220"
          x1="-3.00778"
          y1="15.5"
          x2="1.52078"
          y2="23.0199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_278:11220"
          x1="-3.00778"
          y1="7.49999"
          x2="1.52078"
          y2="15.0199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SorterDoubleArrow;
